// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"332":"0811fdc4","2806":"02dbb82f","6307":"7647c514","8857":"5be29d3f"}[chunkId] + ".chunk.css";
};